import { useTable } from "react-table";
import { useMemo } from "react";
import {
  defaultDateDisplay,
  formatNumberWithCommas,
  truncateString,
} from "../../../helpers";
import primaryComponents from "../../primaryComponents";
import { useNavigate } from "react-router-dom";
import secondaryComponents from "..";

import { pathConstants } from "../../../routes/pathContants";

const useAllProductsBatchTable = ({ productsBatch }) => {
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: "Batch",
        accessor: "batch_name",
        Cell: ({ cell: { value }, row }) => {
          if (value) {
            return (
              <span
                className="purple--text cursor-pointer"
                onClick={() => {
                  navigate(
                    pathConstants.INVENTORY_PRODUCTS_BATCH_EDIT({
                      id: row?.original?.batch_id,
                    }),
                  );
                }}
              >
                {truncateString(value, 20)}
              </span>
            );
          } else return "-";
        },
      },
      {
        Header: "Product Name",
        accessor: "product_name",
        Cell: ({ cell: { value } }) =>
          value ? truncateString(value, 50) : "N/A",
      },
      {
        Header: "Stock Quantity",
        accessor: "stock_quantity",
        Cell: ({ cell: { value } }) =>
          value ? formatNumberWithCommas(value) : "0",
      },
      {
        Header: "Procurement Date",
        accessor: "procurement_date",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Expiring Date",
        accessor: "expiry_date",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <secondaryComponents.NavigateWithPermission>
            <primaryComponents.Button
              onClick={() => {
                navigate(
                  pathConstants.INVENTORY_PRODUCTS_BATCH_EDIT({
                    id: row?.original?.batch_id,
                  }),
                );
              }}
              classNames={"btn btn--primary smallBtn mr-2"}
            >
              Edit details
            </primaryComponents.Button>
          </secondaryComponents.NavigateWithPermission>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: productsBatch });
  return {
    instance,
  };
};

export default useAllProductsBatchTable;
